module.exports = __webpack_public_path__ + "img/undraw_playing_fetch_cm19.6daaca14.svg";